import { Spinner } from "@heroui/react";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router";
import { PersistGate } from "redux-persist/integration/react";
import { useSessionBootstrap } from "@/src/auth/hooks/use-session-bootstrap";
import { rootRouter } from "@/src/common/navigations/root-router";
import { persistor, store } from "@/src/common/redux/store";

const AppContent: React.FC = () => {
	const { isHydrating } = useSessionBootstrap();

	if (isHydrating) {
		return (
			<div className="flex min-h-dvh items-center justify-center bg-background">
				<Spinner size="lg" />
			</div>
		);
	}

	return <RouterProvider router={rootRouter} />;
};

const App: React.FC = () => (
	<Provider store={store}>
		<PersistGate persistor={persistor}>
			<AppContent />
		</PersistGate>
	</Provider>
);

export default App;
